<script lang="ts" setup>
import type { LayoutSettings } from '~~/server/api/pagebuilder'
import type { BoxPosition } from '~/components/box/Box.vue'

export interface SingleContainerProps {
    data: {
        left_column: any[]
        right_column: any[]
    }
    layoutSettings?: LayoutSettings
    components: any
}
const props = defineProps<SingleContainerProps>()

const position = computed<BoxPosition>((): BoxPosition => {
    if (props.layoutSettings?.graphic_element_position === 'right')
        return 'top-right'
    return 'top-left'
})

</script>
<template>
  <ContainerFluid class="mb-10 mb-lg-20">
    <Box
      :color="props.layoutSettings?.layout_css"
      :padding="
        props.layoutSettings?.layout_css === 'transparent'
          ? 'p-0 m-0'
          : undefined
      "
      :decor-position="position"
      :decor="props.layoutSettings?.graphic_element_position !== 'back'"
    >
      <BoxHeader
        v-if="props.layoutSettings?.title"
        :heading="props.layoutSettings.title"
        :subtitle="props.layoutSettings.subtitle"
        heading-level="h2"
      />
      <div class="row">
        <div class="col-12 col-md-8 mb-4 mb-md-0">
          <component
            :is="props.components[component._component_code]"
            v-for="(component, index) in props.data.left_column"
            :id="useSlug(component._component_anchor)"
            :key="`lc-${index}`"
            :data-scroll-id="component._component_anchor ? useSlug(component._component_anchor) : null"
            class="scroll-margin-top-20 scroll-margin-top-md-10"
            :data="component.data"
          />
        </div>
        <div class="col-12 col-md-4">
          <component
            :is="props.components[component._component_code]"
            v-for="(component, index) in props.data.right_column"
            :id="useSlug(component._component_anchor)"
            :key="`rc${index}`"
            :data-scroll-id="component._component_anchor ? useSlug(component._component_anchor) : null"
            class="scroll-margin-top-20 scroll-margin-top-md-10"
            :data="component.data"
          />
        </div>
      </div>
    </Box>
  </ContainerFluid>
</template>
